import { driveThumbnailUrl } from '../lib/drive';

/**
 * Small thumbnail that expands to a large floating preview on hover — the
 * Drive-thumbnail trick from v1, so people can check how an influencer,
 * product or location actually looks before committing a render to it.
 */
export default function ThumbPreview({
  url,
  alt,
  className = 'w-16 h-16',
}: {
  url?: string;
  alt: string;
  /** Size classes for the small thumbnail; the hover preview is always large. */
  className?: string;
}) {
  if (!url) return null;
  return (
    <div className="relative group/thumb shrink-0">
      <img
        src={driveThumbnailUrl(url, 'w200')}
        alt={alt}
        referrerPolicy="no-referrer"
        loading="lazy"
        className={`${className} rounded-xl object-cover border border-natural-border bg-stone-100 cursor-zoom-in`}
      />
      <div className="absolute left-full top-1/2 -translate-y-1/2 ml-3 hidden group-hover/thumb:block z-50 pointer-events-none">
        <div className="bg-white p-2.5 rounded-2xl border border-natural-border shadow-2xl w-[360px] max-w-[80vw]">
          <img
            src={driveThumbnailUrl(url, 'w1000')}
            alt={alt}
            referrerPolicy="no-referrer"
            className="w-full h-auto max-h-[480px] rounded-xl object-contain"
          />
        </div>
      </div>
    </div>
  );
}
